import { Grid } from "@mui/material";
import MainContainer from "../MainContainer";
import "./styles.css";
import { Box } from "@mui/material";
import { ParagraphText, UBButton } from "../../../Libraries";
import { DropDown } from "../../../assets/icons/icon";
import TestimonialsSlider from "../TestimonialsSlider";
import PopoverMenu from "../PopoverMenu";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const LandingPage = ({ data }) => {
  const {
    heroTitle,
    heroImage,
    icon,
    userCount,
    userCoutDescription,
    features,
    handleContact,
    heroAddContact,
    userCountActionTitle,
    userCountAction,
    testimonialsHeading,
    popoverButton = false,
    popoverButtonTitle,
    popoverOptions,
    userPopoverButton = false,
    userPopoverButtonTitle,
    userPopoverOptions,
    testimonials = [],
    id = "",
  } = data;

  return (
    <MainContainer className="NewDesignWrapper landingPageWrapper" fluid>
      <Grid container>
        <Grid item md={12}>
          {/* Hero Section */}
          <Box className="heroSection">
            <Box className="heroSectionLeft">
              <h1
                id={`${id}_landing_head_title`}
                className="fontSize48 blue800Color"
                dangerouslySetInnerHTML={{ __html: heroTitle }}
              />
              <Box className="heroActions">
                {popoverButton ? (
                  <PopoverMenu
                    id={`${id}`}
                    popoverButtonClassName={`heroDropdownButton`}
                    popoverButton={popoverButtonTitle}
                    popoverButtonRestProps={{
                      iconRightSideComponent: (
                        <DropDown width={"20px"} height={"20px"} />
                      ),
                    }}
                    popOverStyle={{ width: "200px" }}
                    menuOptions={popoverOptions}
                  />
                ) : (
                  <UBButton
                    id={`${id}_add_btn`}
                    title={heroAddContact}
                    className="foundationBlueNormalBg foundationWhite textUppercase"
                    onClick={() => {
                      triggerLogEvent(analytics, "login_landing_cta", { section: "hero", page_id: id });
                      handleContact();
                    }}
                  />
                )}
              </Box>
            </Box>
            <Box className="heroSectionRight">
              <img
                src={heroImage}
                alt="Monitor Graphic"
                width={400}
                height={300}
                className="object-contain"
              />
            </Box>
          </Box>

          {/* Feature Section */}
          <Box className="featureSection">
            {features.map((feature, idx) => (
              <Box
                className="featureSectionInner"
                key={idx}
                id={`${id}_${idx}`}
              >
                <Box
                  className="featureSectionImage"
                  sx={{
                    backgroundColor:
                      feature.backgroundColor || "var(--foundationBlue)",
                  }}
                >
                  <img src={feature.image} alt={feature.title} />
                </Box>
                <Box className="featureSectionDescription">
                  <h3 className="newFontColor fontSize16 fontWeight500">
                    {feature.title}
                  </h3>
                  <ParagraphText className="newFontColor fontSize14 fontWeight400">
                    {feature.description}
                  </ParagraphText>
                </Box>
                {feature.action && (
                  <Box className="featureSectionAction">
                    <UBButton
                      id={`${id}_${idx}_btn`}
                      title={feature.actionTitle}
                      className="buttonTeritary textUppercase"
                      onClick={() => {
                        triggerLogEvent(analytics, "login_landing_cta", { section: "feature", feature_index: idx, page_id: id });
                        feature.handleAction();
                      }}
                    />
                  </Box>
                )}
              </Box>
            ))}
          </Box>

          {/* User Count Section */}
          {userCoutDescription && (
            <Box className="userCountSection">
              <Box className="userCountLeft">
                <ParagraphText className="newFontColor fontSize28 fontWeight500">
                  <span>{icon}</span>
                  <span className="foundationBlueDarkColor marginLeft15">
                    {userCount}
                  </span>
                  <span className="marginLeft5">{userCoutDescription}</span>
                </ParagraphText>
              </Box>
              <Box className="userCountRight">
                {userPopoverButton ? (
                  <PopoverMenu
                    id={`${id}_user_coun`}
                    popoverButtonClassName={`heroDropdownButton`}
                    popoverButton={userPopoverButtonTitle}
                    popoverButtonRestProps={{
                      iconRightSideComponent: (
                        <DropDown width={"20px"} height={"20px"} />
                      ),
                    }}
                    popOverStyle={{ width: "200px" }}
                    menuOptions={userPopoverOptions}
                  />
                ) : (
                  <UBButton
                    id={`${id}_user_count_btn`}
                    title={userCountActionTitle}
                    className="foundationBlueNormalBg foundationWhite textUppercase"
                    onClick={() => {
                      triggerLogEvent(analytics, "login_landing_cta", { section: "user_count", page_id: id });
                      userCountAction();
                    }}
                  />
                )}
              </Box>
            </Box>
          )}

          {testimonials.length > 0 && (
            <Box className="testimonialSection">
              <h3 className="newFontColor fontSize28 fontWeight500 textCapitalize">
                {testimonialsHeading}
              </h3>
              <Box className="testimonialContent">
                <TestimonialsSlider testimonials={testimonials} />
              </Box>
            </Box>
          )}
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default LandingPage;
